var React = require('react');

function TickPurpleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m10.5375 14.925 14.175-14.175 5.2875 5.2875-19.4625 19.4625-10.5375-10.5375 5.2875-5.2875zm15.925-8.8875-1.75-1.75-14.175 14.175-5.25-5.25-1.75 1.75 7 7z","fill":"#3d278a","fillRule":"evenodd"}));
}

TickPurpleIcon.defaultProps = {"fill":"none","height":"26","viewBox":"0 0 30 26","width":"30"};

module.exports = TickPurpleIcon;

TickPurpleIcon.default = TickPurpleIcon;
